import { Flex, SegmentedPicker, Text } from './shared';
import { useEffect, useState } from 'react';
import { useTestContext } from '../../../context/testContext';

const ResponsiveEyeSelection = ({ setCanProgress, selectLetters, selectCrowding, selectOptotypeAmount }) => {
  const [selectedLetters, setSelectedLetters] = useState('Sloan');
  const [selectedEye, setSelectedEye] = useState(null);
  const [selectedCorrection, setSelectedCorrection] = useState(null);
  const [selectedCrowding, setSelectedCrowding] = useState('Crowded');
  const [optotypesToShow, setOptotypesToShow] = useState(5);
  const { updateTestData } = useTestContext();

  useEffect(() => {
    const oppositeEye = selectedEye === 'Left' ? 'Right' : 'Left';
    switch (selectedEye) {
      case 'Left':
      case 'Right':
        return updateTestData({ [`test${selectedEye}Eye`]: true, [`test${oppositeEye}Eye`]: false, testBothEyes: false });
      case 'Right then Left':
        return updateTestData({ testLeftEye: true, testRightEye: true, testBothEyes: false });
      case 'Binocular':
        return updateTestData({ testBothEyes: true, testLeftEye: false, testRightEye: false });
      default:
        return updateTestData({ testLeftEye: false, testRightEye: false, testBothEyes: false });
    }
  }, [selectedEye, updateTestData]);

  useEffect(() => {
    if (selectedCorrection === 'Corrected') {
      return updateTestData({ corrected: true });
    } else return updateTestData({ corrected: false });
  }, [selectedCorrection, updateTestData]);

  useEffect(() => {
    updateTestData({ lettersToUse: selectedLetters.includes('Glasgow') ? 'glasgow' : selectedLetters.toLowerCase() });
  }, [updateTestData, selectedLetters]);

  useEffect(() => {
    updateTestData({ kaysCrowding: selectedCrowding.toLowerCase() });
  }, [updateTestData, selectedCrowding]);

  useEffect(() => {
    updateTestData({ optotypesToShow });
  }, [optotypesToShow, updateTestData]);

  useEffect(() => {
    if (selectedEye && selectedCorrection) setCanProgress(true);
  }, [selectedEye, selectedCorrection, setCanProgress]);

  useEffect(() => {
    updateTestData({
      testLeftEye: false,
      testRightEye: false,
      testBothEyes: false,
      leftEye: null,
      rightEye: null,
      bothEyes: null,
    });
  }, [updateTestData]);

  return (
    <Flex column centered>
      <Text size='subHeading' marginBottom='0.5rem'>
        Select Eye
      </Text>
      <SegmentedPicker
        marginBottom='2rem'
        options={['Left', 'Right', 'Right then Left', 'Binocular']}
        selectedOption={selectedEye}
        setSelectedOption={setSelectedEye}
      />
      <Flex justifyContent='space-around' minWidth='600px' maxWidth='700px' marginBottom='2rem'>
        <Flex column centered>
          <Text size='subHeading' marginBottom='0.5rem'>
            Corrected/Uncorrected
          </Text>
          <SegmentedPicker options={['Corrected', 'Uncorrected']} selectedOption={selectedCorrection} setSelectedOption={setSelectedCorrection} />
        </Flex>
        {selectCrowding && (
          <Flex column centered>
            <Text size='subHeading' marginBottom='0.5rem'>
              Select Crowding
            </Text>
            <SegmentedPicker options={['Crowded', 'Open']} selectedOption={selectedCrowding} setSelectedOption={setSelectedCrowding} />
          </Flex>
        )}
        {selectLetters && (
          <Flex column centered>
            <Text size='subHeading' marginBottom='0.5rem'>
              Letters to Use
            </Text>
            <SegmentedPicker options={['Sloan', 'Glasgow Acuity']} selectedOption={selectedLetters} setSelectedOption={setSelectedLetters} />
          </Flex>
        )}
      </Flex>
      {selectOptotypeAmount && (
        <Flex column centred>
          <Text size='subHeading' marginBottom='0.5rem'>
            Number of Optotypes
          </Text>
          <SegmentedPicker
            options={['Single', 'Multiple']}
            marginBottom='1rem'
            selectedOption={optotypesToShow === 1 ? 'Single' : 'Multiple'}
            setSelectedOption={(opt) => setOptotypesToShow(opt === 'Single' ? 1 : 5)}
          />
        </Flex>
      )}
    </Flex>
  );
};

export default ResponsiveEyeSelection;
